import HotelElementGuest from './hotel_element_guest';

export default HotelElementGuest;
